import { validate } from "com";
import { USER_ENDPOINTS } from "./endpoints";
import type { VerifyEmailChangePayload, VerifyEmailChangeResponse } from "./types";
import { apiPost } from "../shared";

export default async function verifyEmailChange(token: string): Promise<VerifyEmailChangeResponse> {
  validate.string(token, "Token");

  const payload: VerifyEmailChangePayload = { token };
  return apiPost<VerifyEmailChangeResponse>(USER_ENDPOINTS.VERIFY_EMAIL_CHANGE, payload);
}
